import { UPLOAD_STATUS } from '../../constants'
export const UPLOADING_LIST = [
    ['channelName', '渠道包名称'],
    ['appName', 'APP名称'],
    ['progress', '上传进度'],
    ['operate', '操作'],
]
export const FILE_UPLOADING_STATUS_NAME = {
    [UPLOAD_STATUS.WAIT]: '待上传',
    [UPLOAD_STATUS.UPLOADING]: '上传中',
    [UPLOAD_STATUS.DONE]: '已完成',
    [UPLOAD_STATUS.FAIL]: '上传失败',
    [UPLOAD_STATUS.CANCEL]: '取消上传',
}

export const FILE_UPLOADING_STATUS = [
    {
        label: '全部状态',
        value: -1,
    },
].concat(
    Object.values(UPLOAD_STATUS).map(status => {
        return {
            label: FILE_UPLOADING_STATUS_NAME[status],
            value: status,
        }
    })
)
export const canCancelUploadStatus = [UPLOAD_STATUS.WAIT, UPLOAD_STATUS.UPLOADING]
